import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  showText?: boolean;
}

const Logo = ({ className, iconClassName, textClassName, showText = true }: LogoProps) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div 
        className={cn(
          "w-8 h-8 rounded-lg flex items-center justify-center shrink-0 bg-linear-to-br from-emerald-500 to-emerald-600 relative overflow-hidden",
          iconClassName
        )}
      >
        <div className="absolute w-5 h-5 bg-linear-to-br from-yellow-400 to-yellow-500 rotate-45" />
        <div className="absolute w-2 h-2 bg-blue-600 rounded-full" />
      </div>
      {showText && (
        <span className={cn("text-xl font-bold truncate", textClassName)}>
          Portal CIB
        </span>
      )}
    </div>
  );
};

export default Logo;
